import React, { useState, useEffect } from 'react'
import Navbar from '../../components/Navbar'
import Footer from '../../components/Footer'
import { Typography, Button } from '@mui/material'
import FileDownloadOutlinedIcon from '@mui/icons-material/FileDownloadOutlined'
import CountUp from 'react-countup'
import { getPortfolioCategory } from '../../api'
import heat_pump_catalogue from '../../Catalogues/heat_pump_catalogue.pdf'
import ProductShowcase from './ProductShowcase'

function Heatpump() {
  const [products, setProducts] = useState([])

  useEffect(() => {
    getPortfolioCategory('heat_pump').then(setProducts).catch(() => {})
  }, [])

  return (
    <>
      <Navbar />

      <main className='page-shell'>
        <div className='page-title-block'>
          <Typography className='page-title'>Heat Pumps</Typography>

          <Typography className='page-subtitle'>
            We make heating water systems for <span style={{ color: 'var(--text-main)', fontWeight: 600 }}>hostels</span>,{' '}
            <span style={{ color: 'var(--text-main)', fontWeight: 600 }}>hotels</span> and{' '}
            <span style={{ color: 'var(--text-main)', fontWeight: 600 }}>swimming pools</span>
          </Typography>

          <Typography className='page-subtitle'>
            Running cost less than <span style={{ color: 'var(--text-main)', fontWeight: 800 }}><CountUp start={100} end={50} duration={2} />%</span> of boiler and{' '}
            <span style={{ color: 'var(--text-main)', fontWeight: 800 }}><CountUp start={100} end={25} duration={2} />%</span> of electric geyser
          </Typography>

          <div className='pp-cta-row'>
            <a href={heat_pump_catalogue} download='celsius-heat-pump'>
              <Button className='pp-cta-btn' startIcon={<FileDownloadOutlinedIcon />}>
                Catalogue (PDF)
              </Button>
            </a>
          </div>
        </div>

        <div className='page-stack'>
          {products.map((p, i) => (
            <ProductShowcase
              key={i}
              title={p.specs.site}
              subtitle={p.specs.application}
              images={p.image_paths}
              specs={[
                { label: 'Installation', value: p.specs.installation },
                { label: 'Heating capacity', value: p.specs.heatingCapacity },
                { label: 'Power input', value: p.specs.powerInput },
              ]}
              badges={[p.specs.extraText]}
            />
          ))}
        </div>
      </main>

      <Footer />
    </>
  )
}

export default Heatpump
